import TabList, { tablistPropsManager } from '../tabList/tabList.js';
import TabListFactory from '../tabList/tabList.factory.js';
import PanelList from '../panelList/panelList.js';
import TablistView, { tablistViewPropsManager } from '../tablistView/tablistView.js';
import TablistViewFactory from '../tablistView/tablistView.factory.js';
import TablistContainer, { tablistContainerPropsManager } from '../tablistContainer/tablistContainer.js';
import TablistContainerFactory from '../tablistContainer/tablistContainer.factory.js';
import TablistOverflow, { tablistOverflowPropsManager } from '../tablistOverflow/tablistOverflow.js';
import TablistOverflowFactory from '../tablistOverflow/tablistOverflow.factory.js';
import Tabs, { TabsPropsManager } from '../tabs/tabs.js';
import TabsFactory from '../tabs/tabs.factory.js';
import Tab, { tabPropsManager, tabInnerPropsManager, closeIconPropsManager, memomizeTab } from '../tab/tab.js';
import TabFactory from '../tab/tab.factory.js';
import { useApi, useRootState, useForceUpdate } from '../hooks.js';
export default {
  TablistView: TablistView,
  tablistViewPropsManager: tablistViewPropsManager,
  TablistViewFactory: TablistViewFactory,
  TablistContainer: TablistContainer,
  tablistContainerPropsManager: tablistContainerPropsManager,
  TablistContainerFactory: TablistContainerFactory,
  TablistOverflow: TablistOverflow,
  TablistOverflowFactory: TablistOverflowFactory,
  tablistOverflowPropsManager: tablistOverflowPropsManager,
  TabList: TabList,
  tablistPropsManager: tablistPropsManager,
  TabListFactory: TabListFactory,
  Tabs: Tabs,
  TabsPropsManager: TabsPropsManager,
  TabsFactory: TabsFactory,
  Tab: Tab,
  tabPropsManager: tabPropsManager,
  tabInnerPropsManager: tabInnerPropsManager,
  closeIconPropsManager: closeIconPropsManager,
  memomizeTab: memomizeTab,
  TabFactory: TabFactory,
  PanelList: PanelList,
  useApi: useApi,
  useRootState: useRootState,
  useForceUpdate: useForceUpdate
};